import React from 'react';
import styled from 'styled-components';
import { SpaceBetween } from '../../utils/common';
import { Box } from '../home/TotalMembers';

const CardTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
`;

const Filter = styled.p`
  font-size: 12px;
  color: #767a81;
`;

export default function RepaymentProgress() {
  return (
    <Box>
      <SpaceBetween>
        <CardTitle>Repayment Progress</CardTitle>
        <Filter>Last 30 days</Filter>
      </SpaceBetween>
    </Box>
  );
}
